import { createAsyncThunk, createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import authAxios from 'utils/authAxios';

// Thunks
export const fetchAdminUsers = createAsyncThunk(
  'adminUser/fetchAdminUsers',
  async (params = {}) => {
    return authAxios.get('/admin-api/users/', { params }).then(response => response.data);
  }
);

export const updateUserType = createAsyncThunk(
  'adminUser/updateUserType',
  async ({ userId, userType }) => {
    return authAxios.patch(`/admin-api/users/${userId}/`, {
      user_type: userType
    }).then(response => response.data);
  }
);

export const updateUserData = createAsyncThunk(
  'adminUser/updateUserData',
  async ({ userId, userData }) => {
    return authAxios.patch(`/admin-api/users/${userId}/`, userData)
      .then(response => response.data);
  }
);

// Create entity adapter
export const adminUsersAdapter = createEntityAdapter({
  // Using the 'id' field as the key
  selectId: (user) => user.id
});

// Initial state with loading, error, and entities
const initialState = adminUsersAdapter.getInitialState({
  loading: false,
  error: null
});

// Create the slice
export const adminUserSlice = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch users
      .addCase(fetchAdminUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminUsers.fulfilled, (state, action) => {
        adminUsersAdapter.setAll(state, action.payload);
        state.loading = false;
      })
      .addCase(fetchAdminUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      // Update user type (legacy, kept for backward compatibility)
      .addCase(updateUserType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserType.fulfilled, (state, action) => {
        adminUsersAdapter.upsertOne(state, action.payload);
        state.loading = false;
      })
      .addCase(updateUserType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      // Update user data (new - handles all user fields)
      .addCase(updateUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserData.fulfilled, (state, action) => {
        adminUsersAdapter.upsertOne(state, action.payload);
        state.loading = false;
      })
      .addCase(updateUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

// Export selectors
export const {
  selectAll: selectAllAdminUsers,
  selectById: selectAdminUserById,
  selectIds: selectAdminUserIds
} = adminUsersAdapter.getSelectors((state) => state.adminUser);

export default adminUserSlice.reducer; 